import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { track } from "@/lib/analytics";

const anchors = [
  { label: "Who We Are", href: "#who-we-are" },
  { label: "What You Get", href: "#what-you-get" },
  { label: "Who It's For", href: "#who-its-for" },
  { label: "What We Review", href: "#what-we-review" },
  { label: "How It Works", href: "#how-it-works" },
];

const CheckupNavbar = () => {
  const [open, setOpen] = useState(false);

  const scrollTo = (id: string, source: "nav_anchor" | "nav_cta" | "mobile_nav_anchor" | "mobile_nav_cta" = "nav_anchor", label?: string) => {
    setOpen(false);
    if (id === "#checkup-form") {
      track("nav_cta_clicked", { source, label: label ?? "Get My Checkup" });
    } else {
      track("nav_anchor_clicked", { source, anchor: id, label });
    }
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-hero-bg/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto section-padding flex items-center justify-between h-16 md:h-20">
        <a href="/GetGrowthScore" className="text-lg md:text-xl font-bold text-hero-foreground tracking-tight">
          Xpress Inc
        </a>

        <div className="hidden md:flex items-center gap-8">
          {anchors.map((a) => (
            <button
              key={a.label}
              onClick={() => scrollTo(a.href, "nav_anchor", a.label)}
              className="text-sm font-medium text-hero-foreground/70 hover:text-hero-foreground transition-colors"
            >
              {a.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => scrollTo("#checkup-form", "nav_cta", "Get My Checkup")}
          className="hidden md:flex items-center gap-2 bg-accent text-accent-foreground px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-accent/90 transition-colors active:scale-[0.97]"
        >
          Get My Checkup
        </button>

        <button onClick={() => setOpen(!open)} className="md:hidden text-hero-foreground p-2" aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-hero-bg border-t border-hero-foreground/10 px-6 py-6 space-y-4">
          {anchors.map((a) => (
            <button
              key={a.label}
              onClick={() => scrollTo(a.href, "mobile_nav_anchor", a.label)}
              className="block text-base font-medium text-hero-foreground/80 hover:text-hero-foreground"
            >
              {a.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("#checkup-form", "mobile_nav_cta", "Get My Checkup")}
            className="flex items-center gap-2 bg-accent text-accent-foreground px-5 py-3 rounded-lg text-sm font-semibold w-fit"
          >
            Get My Checkup
          </button>
        </div>
      )}
    </nav>
  );
};

export default CheckupNavbar;
